import { render, staticRenderFns } from "./ProjectGroupEdit.vue?vue&type=template&id=00741eef&scoped=true&"
import script from "./ProjectGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroupEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectGroupEdit.vue?vue&type=style&index=0&id=00741eef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00741eef",
  null
  
)

export default component.exports